import { keysToCamelFromSnake } from '../utils/caseconverters';

export async function getFlowmapChunk(page = 1, pageSize = 500) {
    const url = `/wt/fenix/graphs/data/flowmap/?page=${page}&page_size=${pageSize}`;
    const res = await fetch(url, {
        headers: { 'Content-Type': 'application/json' },
        cache: 'no-store',
    });

    if (!res.ok) {
        throw new Error(`Flowmap fetch failed: ${res.status}`);
    }

    const data = keysToCamelFromSnake(await res.json(), false);
    const items = data.items || [];
    const hasMore = items.length >= pageSize;

    return { items, hasMore };
}
